import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { PassfeetService } from "@core/services/passfeet.service";
import { Observable } from "rxjs";

@Injectable()
export class QRCodeResolver implements Resolve<any> {
  private readonly passfeetService = inject(PassfeetService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    return this.passfeetService.getQRCode()
  }
}
